
(function () {
  var PER_PAGE = 5;
  var cards = document.querySelectorAll('.media-page .announce-card');
  var nav = document.getElementById('pagination');
  if (!nav) return;
  var totalPages = Math.ceil(cards.length / PER_PAGE);
  var current = 1;

  function showPage(page) {
    current = page;
    cards.forEach(function (card, i) {
      card.style.display = (i >= (page - 1) * PER_PAGE && i < page * PER_PAGE) ? '' : 'none';
    });
    renderNav();
  }

  function makeBtn(label, page, opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = label;
    if (opts && opts.active) b.className = 'active';
    if (opts && opts.arrow) b.className = 'arrow';
    if (opts && opts.disabled) b.disabled = true;
    if (!(opts && opts.disabled)) {
      b.addEventListener('click', function () {
        showPage(page);
        document.querySelector('.media-page .container').scrollIntoView({ behavior: 'smooth' });
      });
    }
    return b;
  }

  function renderNav() {
    nav.innerHTML = '';
    if (totalPages <= 1) return;
    nav.appendChild(makeBtn('\u2190', current - 1, { arrow: true, disabled: current === 1 }));

    var show = {};
    [1, totalPages, current - 1, current, current + 1].forEach(function (n) { show[n] = true; });
    if (current <= 2) { show[2] = true; show[3] = true; }
    if (current >= totalPages - 1) { show[totalPages - 1] = true; show[totalPages - 2] = true; }

    var last = 0;
    for (var p = 1; p <= totalPages; p++) {
      if (!show[p]) continue;
      if (p - last > 1) nav.appendChild(makeBtn('...', 0, { disabled: true }));
      nav.appendChild(makeBtn(p, p, { active: p === current }));
      last = p;
    }
    nav.appendChild(makeBtn('\u2192', current + 1, { arrow: true, disabled: current === totalPages }));
  }

  showPage(1);
})();
